import appStore from "../../store/appStore";
export default function constructMaintenancePageGuard() {
  const maintenanceData =
    appStore.state.config.configurationData.maintenanceInfo;
  let isRequiresAuthAppsUnderMaintenance = false;
  let underMaintenancePath = [];
  let underMaintenanceMessage = {};

  maintenanceData &&
    maintenanceData.length > 0 &&
    maintenanceData.forEach(data => {
      if (Array.isArray(data.path)) {
        data.path.forEach(maintenancePath => {
          if (maintenancePath === "/" && data.isUnderMaintenance) {
            isRequiresAuthAppsUnderMaintenance = true;
            underMaintenanceMessage["/"] = maintenancePath;
          } else if (data.isUnderMaintenance) {
            underMaintenancePath.push(maintenancePath);
            underMaintenanceMessage[maintenancePath] = data.text;
          }
        });
      } else {
        if (data.path === "/" && data.isUnderMaintenance) {
          isRequiresAuthAppsUnderMaintenance = true;
          underMaintenanceMessage["/"] = data.text;
        } else if (data.isUnderMaintenance) {
          underMaintenancePath.push(data.path);
          underMaintenanceMessage[data.path] = data.text;
        }
      }
    });

  return {
    isRequiresAuthAppsUnderMaintenance,
    underMaintenancePath,
    underMaintenanceMessage
  };
}
